module.exports = __webpack_public_path__ + "static/img/visionPic4.2f31183.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/visionPic4.jpg
// module id = ppAq
// module chunks = 0